import type { OutcomesApi } from "@/v2/api/metadata/outcomes";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { createInheritableTabSave } from "@/v2/kits/tenant-inheritance";
import { outcomeGamesStatusOptions } from "../../../../shared";
import { notifySuccess, outcomeId } from "../shared";

const liveTabChildren: ContentTab["children"] = [
  {
    type: "group",
    name: "liveGame",
    label: "",
    children: [
      {
        type: "select-field",
        name: "status",
        label: "Status",
        required: true,
        placeholder: "Select status",
        options: outcomeGamesStatusOptions,
        inheritance: { computedKey: "computedStatus", parentKey: "parentStatus" },
      },
    ],
  },
];

export function createLiveTab(outcomesApi: OutcomesApi): ContentTab {
  return {
    id: "live",
    label: "Live",
    save: createInheritableTabSave({
      children: liveTabChildren,
      persist: async (patch, ctx: DialogTabSaveContext) => {
        await outcomesApi.update(outcomeId(ctx.values), patch);
        notifySuccess();
      },
    }),
    children: liveTabChildren,
  };
}
